module.exports = __webpack_public_path__ + "static/media/bg_page17_a.b6630901.jpg";